class CardCustomizerBase extends HTMLElement {

  constructor() {
    super();
    this.available = Boolean(this.getAttribute('available') !== 'false');
    this.parentProductVariantId = this.getAttribute('parent-product-variant-id');
    this.defaultCardProductId = this.getAttribute('default-card-product-id');
    this.matchingCardUrl = this.dataset.matchingCard.includes("Liquid error") ? "" : this.dataset.matchingCard;
    this.topBarImage = this.getAttribute('top-bar-image');
    //this.parentProductData = JSON.parse(this.getAttribute('parent-product-data'));
    const productJson = document.querySelector('[data-product-json]');
    this.parentProductData = JSON.parse(productJson ? productJson.innerHTML : this.getAttribute('parent-product-data'));
    //console.log(this.parentProductData)
    if (this.parentProductData) {
      fetch(`/products/${this.parentProductData.handle}?view=card-customizer-data`).then(r => r.json()).then(json => {
        this.parentProductVariantId = json.parent_product_variant_id
        this.defaultCardProductId = json.default_card_product_id
        this.topBarImage = json.top_bar_image
      })
    }
  }
  
  getAttributesFromProductForm = (form) => {
    const formData = new FormData(form);
  
    // Or with basic conversion:
    const attributes = [];
    for (let [key, value] of formData) {
      if (key.startsWith('properties[')) {
        const propKey = key.match(/\[(.*?)\]/)[1];
        if (propKey != "_drawer_customizer_id") {
          attributes.push({key: propKey, value: value});
        }
      }
    }
    return attributes
  };

  toggleApp() {
    //console.log(this.topBarImage)
    document.querySelector("cart-drawer")?.closeCartDrawer()
    const detail = {
      parentProductVariantId: this.parentProductVariantId,
      defaultCardProductId: this.defaultCardProductId,
      topBarImage: this.topBarImage,
      parentProductData: this.parentProductData,
    }
    const productForm = this.closest(".product__content").querySelector("product-form form");
    if (productForm) {
      detail.parentProductData.attributes = this.getAttributesFromProductForm(productForm)
    }
    console.log('detail', detail);
    window.dispatchEvent(new CustomEvent('ToggleCardCustomizerApp', { detail }));
  }

}

class CardCustomizer extends CardCustomizerBase {
  constructor() {
    super();
    //this.i18n = JSON.parse(this.getAttribute('i18n'));
    this.i18n = {
      card_customizer: { ...window.theme.strings.card_customizer },
      card_customizer_v2: { ...window.theme.strings.card_customizer_v2 },
      card_customizer_v3: { ...window.theme.strings.card_customizer_v3 },
    }
    let isV2Selection = false,
      isV3Selection = false
    try {
      isV2Selection = document.querySelector('[data-new-card-selection]').dataset.newCardSelection === 'true';
    } catch (err) { }
    try {
      isV3Selection = document.querySelector('[data-v3-card-selection]').dataset.v3CardSelection === 'true';
    } catch (err) { }
    if (window.location.href.includes('test=3') || isV3Selection) {
      this.createOptionsV3();
    }
    else if (isV2Selection) {
      this.createOptionsV2();
    }
    else {
      this.createOptions();
    }
    //setup event listeners
    this._onPersonalizeButtonClickListener = this._onPersonalizeButtonClick.bind(this);
    this._onBlankButtonClickListener = this._onBlankButtonClick.bind(this);
  }

  createOptions() {
    this.innerHTML = `
      <div class="card-customizer-options">
        <label for="card-option-blank" class="card-customizer-label selected">
          <div class="card-customizer-label-input"><input type="radio" name="card-customizer-options" id="card-option-blank" value="blank" checked></div>
          <div class="card-customizer-label-title">${this.i18n.card_customizer.card_option_1}</div>
          <div class="card-customizer-label-price">${this.i18n.card_customizer.card_option_1_price}</div>
        </label>
        <label for="card-option-personalized" class="card-customizer-label" style="${this.available ? '' : 'opacity:0.5;'}">
          <div class="card-customizer-label-input"><input${this.available ? '' : ' disabled'} type="radio" name="card-customizer-options" id="card-option-personalized" value="personalized"></div>
          <div class="card-customizer-label-image"><img src="//cdn.shopify.com/s/files/1/0671/6919/0187/files/Custom_Card.png?v=1679511922" alt="custom-card"></div>
          <div class="card-customizer-label-title">
          ${this.i18n.card_customizer.card_option_2}
            <span class="card-customizer-label-subtext">${this.i18n.card_customizer.card_option_2_description}</span>
          </div>
          <div class="card-customizer-label-price">${this.i18n.card_customizer.card_option_2_price}</div>
        </label>
      </div>`;
  }

  createOptionsV2() {
    this.innerHTML = `
      <div class="card-customizer-options">
        <label for="card-option-blank" class="card-customizer-label selected">
          <div class="card-customizer-label-input"><input type="radio" name="card-customizer-options" id="card-option-blank" value="blank" checked></div>
          <div class="card-customizer-label-title">
            ${this.i18n.card_customizer_v2.card_option_1}&nbsp;<span style="font-weight:normal;">${this.i18n.card_customizer_v2.card_option_1_subdued}</span>
            <em class="card-customizer-label-subtext">${this.i18n.card_customizer_v2.card_option_1_description}</em>
          </div>
          <div class="card-customizer-label-price">${this.i18n.card_customizer_v2.card_option_1_price_display_only}</div>
        </label>
        <label for="card-option-personalized" class="card-customizer-label" style="${this.available ? '' : 'opacity:0.5;'}">
          <div class="card-customizer-label-input"><input${this.available ? '' : ' disabled'} type="radio" name="card-customizer-options" id="card-option-personalized" value="personalized"></div>
          <div class="card-customizer-label-image"><img src="//cdn.shopify.com/s/files/1/0671/6919/0187/files/Custom_Card.png?v=1679511922" alt="custom-card"></div>
          <div class="card-customizer-label-title">
            ${this.i18n.card_customizer_v2.card_option_2}
            <em class="card-customizer-label-subtext">${this.i18n.card_customizer_v2.card_option_2_description}</em>
          </div>
          <div class="card-customizer-label-price">${this.i18n.card_customizer_v2.card_option_2_price_display_only}</div>
        </label>
      </div>`;
  }

  createOptionsV3() {
    this.innerHTML = `
      <div class="card-customizer-options card-customizer-options--v3">
        <label for="card-option-blank" class="card-customizer-label selected">
          <div class="card-customizer-label-input"><input type="radio" name="card-customizer-options" id="card-option-blank" value="blank" checked></div>
          <div class="card-customizer-label-image" style="position: relative">
          ${this.matchingCardUrl ?
        `<img src="https://cdn.shopify.com/s/files/1/0264/0124/3198/files/Custom_Card.png?v=1751556902" alt="custom-card">
            <img src="${this.matchingCardUrl}" class="card-customizer-label-matching-card" alt="matching card">` :
        `<img src="//cdn.shopify.com/s/files/1/0264/0124/3198/files/adb5110f86b09aafda5c886a7b85658fc22bb486.png?v=1750263880" alt="custom-card">`
      }
          </div>
          <div class="card-customizer-label-title">
            ${this.i18n.card_customizer_v3.card_option_1}
            <em class="card-customizer-label-subtext">${this.i18n.card_customizer_v3.card_option_1_description}</em>
          </div>
          <div class="pricing-badge">Free</div>
        </label>
        <label for="card-option-personalized" class="card-customizer-label" style="${this.available ? '' : 'opacity:0.5;'}">
          <div class="card-customizer-label-input"><input${this.available ? '' : ' disabled'} type="radio" name="card-customizer-options" id="card-option-personalized" value="personalized"></div>
          <div class="card-customizer-label-image"><img src="//cdn.shopify.com/s/files/1/0671/6919/0187/files/Custom_Card.png?v=1679511922" alt="custom-card"></div>
          <div class="card-customizer-label-title">
            ${this.i18n.card_customizer_v3.card_option_2}
            <em class="card-customizer-label-subtext">${this.i18n.card_customizer_v3.card_option_2_description}</em>
          </div>
          <div class="pricing-badge">$<span>5</span></div>
        </label>
      </div>`;
  }

  updateSelectedOptionDesign() {
    this.querySelector('input[name="card-customizer-options"]:not(:checked)').closest('label').classList.remove('selected');
    this.querySelector('input[name="card-customizer-options"]:checked').closest('label').classList.add('selected');
  }

  _onPersonalizeButtonClick(event) {
    this.updateSelectedOptionDesign();
    this.toggleApp.apply(this);
  }

  _onBlankButtonClick(event) {
    this.updateSelectedOptionDesign();
  }

  connectedCallback() {
    //subscribe to events
    this.querySelector('#card-option-personalized').addEventListener('change', this._onPersonalizeButtonClickListener);
    this.querySelector('#card-option-blank').addEventListener('change', this._onBlankButtonClickListener);
    if (!this.observer) {
      this.observer = new MutationObserver((event) => {
        if (event[0].removedNodes.length) {
          this.querySelector('#card-option-blank').checked = true;
          this.updateSelectedOptionDesign();
        }
      });
    }
    this.observer.observe(document.querySelector('#headlessui-portal-root'), { childList: true });
  }

  disconnectedCallback() {
    //unsubscribe from events
    this.querySelector('#card-option-personalized').removeEventListener('change', this._onPersonalizeButtonClickListener);
    this.querySelector('#card-option-blank').removeEventListener('change', this._onBlankButtonClickListener);
    this.observer.disconnect();
  }
}

customElements.define('card-customizer', CardCustomizer);

class CardCustomizerSticky extends CardCustomizerBase {

  constructor() {
    super();
    //for testing purposes
    if (window.location.href.includes('sticky=1')) {
      document.querySelector('.product__fcp-sticky-customizer').style.display = 'block'
    }
    this._onPersonalizeButtonClickListener = this._onPersonalizeButtonClick.bind(this);
  }

  _onPersonalizeButtonClick(event) {
    this.toggleApp.apply(this);
  }

  connectedCallback() {
    //subscribe to events
    this.addEventListener('click', this._onPersonalizeButtonClickListener);
  }

  disconnectedCallback() {
    //unsubscribe from events
    this.removeEventListener('click', this._onPersonalizeButtonClickListener);
  }

}

customElements.define('card-customizer-sticky', CardCustomizerSticky);

(function () {
  /* ======================== CART HELPER FUNCTIONS ======================== */
  const Cart = {
    get: () => fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json()),
    update: (changes) => {
      fetch(
        `${window.Shopify.routes.root}cart/update.js`,
        {
          body: JSON.stringify(changes),
          headers: { "Content-Type": "application/json" },
          method: "POST",
        },
      )
        .then(() => document.querySelector("cart-items").getCart())
        .then(() => setDrawerLoadingState(false))
        .catch(console.error);
    },
  };

  /* ======================== OTHER HELPER FUNCTIONS ======================== */
  // Toggle the cart drawer's checkout button disabled state
  function setDrawerLoadingState(is_loading) {
    const checkout_button = document.querySelector("[name=\"checkout\"]");

    if (is_loading === true) {
      checkout_button.setAttribute("disabled", true);
    }
    else {
      checkout_button.removeAttribute("disabled");
    }
  }

  /* =========================== EVENT LISTENERS =========================== */
  let last_cart_count = -1;

  // Whenever the cart updates Sync product and custom card inventories
  document.addEventListener("theme:cart:change", async (event) => {
    setDrawerLoadingState(true);

    // Get the cart
    const cart = await Cart.get();

    // Return if cart is not initialised
    if (Array.isArray(cart.items) === false) {
      return;
    }

    // If the cart is the same as last time this event was triggered then
    // end this function
    if (cart.item_count === last_cart_count) {
      setDrawerLoadingState(false);
      return;
    }

    // Update last item count
    last_cart_count = cart.item_count;

    // Filter out just the card items
    const cards = cart.items.filter(i => i.product_type == "greeting_card");

    // Object for holding changes
    const updates = {};

    // Loop through each card
    cards.forEach(card => {
      // The card UUID from the line item properties and the parent product
      const card_uuid = card.properties._card_customizer_uuid;
      const parent_product = cart.items.find(i => i.properties._card_customizer_uuid == card_uuid && i.id !== card.id);

      if (!parent_product) {
        // If the parent product doesn't exist then remove this card
        updates[card.key] = 0;
      }
      else if ([undefined, null, ""].includes(card_uuid)) {
        // If the card doesn't have a UUID then remove it (will happen when
        // customers click on "buy again" post-checkout)
        updates[card.key] = 0;
      }
      else if (card.quantity !== parent_product.quantity) {
        // Sync the quantity with the parent product if not the same
        updates[card.key] = parent_product.quantity;
      }
    });

    // Push the changes to the cart
    if (Object.keys(updates).length > 0) {
      Cart.update({ updates });
    }
    else {
      setDrawerLoadingState(false);
    }
  });

  // Attach event listeners to "edit" and "remove" buttons in cart line items
  // for custom card and product groupings
  document.addEventListener("DOMContentLoaded", () => {
    const handleEdit = (target) => {
      const cart_close_button = document.querySelector("[data-cart-drawer-close]");

      if (cart_close_button) {
        cart_close_button.click();
      }
      document.querySelector("cart-drawer")?.closeCartDrawer()

      window.dispatchEvent(new CustomEvent("ToggleCardCustomizerApp", {
        detail: {
          customizationUuid: target.closest(".cart__item").getAttribute("data-card-customizer-uuid"),
        },
      }));
    };

    const handleRemove = async (target) => {
      setDrawerLoadingState(true);

      const cart = await Cart.get();

      const updates = {};

      const items = target.closest(".cart__item--grouped").querySelectorAll(".cart__item");

      items.forEach((item) => {
        updates[item.getAttribute("data-key")] = 0;
      });

      Cart.update({ updates });
    }

    document.addEventListener("click", event => {
      if (event.target.classList.contains("cart__item--grouped__remove")) {
        handleRemove(event.target);
      }

      if (event.target.classList.contains("cart__item--grouped__edit")) {
        handleEdit(event.target);
      }
    });
  });

  // This was used just for Intelligems but we're no longer using it which
  // is why it's commented out

  // Refresh the cart after 2s when a custom card is added to the cart
  // otherwise cart transforms will not be shown correctly
  // document.addEventListener("ajaxProduct:added", () => {
  //   setTimeout(() => document.querySelector("cart-items").getCart(), 2000);
  // });

  /* ============================ INITIALISATION ============================ */
  // Send an empty cart update on page load to initialise the cart. This is
  // needed otherwise sometimes the card customizer fails to add products to
  // the cart due to the token being invalid. We ignore any errors since it
  // will throw an error if the cart is already initialised.
  fetch(
    `${window.Shopify.routes.root}cart/update.js`,
    {
      body: JSON.stringify({ updates: {} }),
      headers: { "Content-Type": "application/json" },
      method: "POST",
    },
  )
    .then(response => { })
    .catch(error => { });

  // Check cart for cards without a UUID (will happen when customers click on
  // "buy again" post-checkout)
  async function initialise() {
    // Get the cart
    const cart = await Cart.get();

    // Return if cart is not initialised
    if (Array.isArray(cart.items) === false) {
      return;
    }

    // Filter out just the card items
    const cards = cart.items.filter(i => i.product_type == "greeting_card");

    // Object for holding changes
    const updates = {};
    let updated = false;

    // Loop through each card
    cards.forEach(card => {
      // The card UUID from the line item properties and the parent product
      const card_uuid = card.properties._card_customizer_uuid;

      if ([undefined, null, ""].includes(card_uuid)) {
        updates[card.key] = 0;

        updated = true;
      }
    });

    // Push the changes to the cart
    if (updated) {
      Cart.update({ updates });
    }
    else {
      setDrawerLoadingState(false);
    }
  }

  initialise();

  //fill simple atc button form with random id to connect customizer app with cart item
  document.querySelectorAll('[name="properties[_drawer_customizer_id]"]').forEach(el => el.value = Math.random().toString().split('.')[1])

  //customizer button on collection pages
  Array.prototype.forEach.call(document.querySelectorAll('[data-collection-customizer-button]'), btn => {
    btn.addEventListener("click", e => {
      let data = { ...btn.dataset }
      data.parentProductData = JSON.parse(data.parentProductData)
      document.querySelector("cart-drawer")?.closeCartDrawer()
      window.dispatchEvent(new CustomEvent('ToggleCardCustomizerApp', {
        detail: data
      }))
      e.stopPropagation()
    })
  })

  //customizer button in cart drawer
  const _onDrawerCustomizerButtonClick = e => {
    let data = { ...e.currentTarget.dataset }
    data.parentProductData = JSON.parse(data.parentProductData)
    document.querySelector("cart-drawer")?.closeCartDrawer()
    window.dispatchEvent(new CustomEvent('ToggleCardCustomizerApp', {
      detail: data
    }))
    e.stopPropagation()
  }
  document.addEventListener('theme:cart-drawer:open', () => {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-customizer-button]'), btn => {
      btn.removeEventListener("click", _onDrawerCustomizerButtonClick)
      btn.addEventListener("click", _onDrawerCustomizerButtonClick)
    })
  })
  document.addEventListener('theme:cart:change', () => {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-customizer-button]'), btn => {
      btn.removeEventListener("click", _onDrawerCustomizerButtonClick)
      btn.addEventListener("click", _onDrawerCustomizerButtonClick)
    })
  })
  setTimeout(() => {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-customizer-button]'), btn => {
      btn.removeEventListener("click", _onDrawerCustomizerButtonClick)
      btn.addEventListener("click", _onDrawerCustomizerButtonClick)
    })
  }, 500);
})();
